import { useEffect } from 'react';

import { getApiKey, getConfigValue, region as getRegion } from 'utils/environment';
import { isLocalDev } from 'utils/environment';
import { loadLanguage } from 'utils/intl/language';
import logger from 'utils/logger';

import { initializeBraze, requestImmediateDataFlush, setLanguage } from './braze-api';

const region = getRegion();
const brazeApiKey = getApiKey({ key: 'braze', defaultValue: '', region });
const brazeUrl = getConfigValue({ key: 'urls', defaultValue: { braze: '' }, region })
  .braze as string;

const initialized = initializeBraze(brazeApiKey, {
  baseUrl: brazeUrl,
  noCookies: true,
  enableLogging: isLocalDev === true,
  allowUserSuppliedJavascript: true,
  sessionTimeoutInSeconds: 60,
  minimumIntervalBetweenTriggerActionsInSeconds: 10,
});

// Do things for braze on app mount / unmount
export const useBrazeLifecycle = () => {
  useEffect(() => {
    if (initialized) {
      setLanguage(loadLanguage());
    } else {
      const errorMessage = '[BRAZE] Uninitialized error';
      logger.error({ message: errorMessage });
    }

    return () => {
      requestImmediateDataFlush();
    };
  }, []);
};
